import { memo } from 'react';
import { Picture } from '@ui';
import { checkSmallWhite } from '@images';
import PropTypes from 'prop-types';
import './index.scss';

const Toggle = ({
  onChange,
  isChecked,
  isDisabled = false,
  isNewStyles = false,
  newClassName = false
}) => (
  <div
    className={`Toggle ${newClassName ? 'updatedStyle' : ''} ${
      isDisabled ? 'isDisabled' : ''
    }`}
  >
    <label className='Toggle__switch'>
      {isChecked && (
        <Picture
          className='Toggle__checkmark'
          icon={checkSmallWhite}
          height={newClassName ? '13' : '16'}
        />
      )}
      <input
        onChange={onChange}
        checked={isChecked}
        disabled={isDisabled}
        className='Toggle__input'
        type='checkbox'
      />
      <span
        className={
          isNewStyles ? ' Toggle__slider isNewStyles' : 'Toggle__slider'
        }
      />
    </label>
  </div>
);

Toggle.propTypes = {
  // content
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  // functions
  onChange: PropTypes.func,
  isNewStyles: PropTypes.bool,
  // string
  newClassName: PropTypes.bool
};

export default memo(Toggle);
